import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

export default function ModelIcon({ ...props }) {
  return (
    <SvgIcon width="16" height="18" viewBox="0 0 16 18" {...props}>
      <path d="M15.5844 0.243293C15.3198 0.0293315 14.9756 -0.0489264 14.6475 0.0301753L5.27515 2.28011C4.77621 2.39957 4.43851 2.85305 4.43851 3.37516V11.4462C4.05888 11.3215 3.70796 11.2501 3.32012 11.2501C1.49033 11.2501 0 12.7611 0 14.625C0 16.489 1.47659 18 3.30638 18C5.13617 18 6.61276 16.489 6.61276 14.625V8.20359L13.7912 6.48301V10.3212C13.4461 10.1965 13.0779 10.1251 12.69 10.1251C10.8602 10.1251 9.37851 11.6361 9.37851 13.5C9.37851 15.364 10.8595 16.875 12.6893 16.875C14.5191 16.875 16 15.364 16 13.5V1.12519C16 0.781606 15.8489 0.456691 15.5844 0.243293ZM6.61276 5.89224V4.26616L13.7912 2.54571V4.17166L6.61276 5.89224Z" />
    </SvgIcon>
  );
}
